import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { useCancelSchedule } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function CancelScheduleButton({ id }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const process = useCancelSchedule();

  async function handleSubmit() {
    try {
      const response = await process({ scheduleId: id });

      if (response.isSuccess) {
        publish("notification", "Schedule cancelled");
        history.goBack();
      } else {
        publish(
          "notification",
          <div>
            Unable to cancel schedule
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </div>
        );
      }
    } catch (e) {
      console.error(e, "error processing");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button large style={{ backgroundColor: "red" }} onClick={() => setDialogOpen(true)}>
        Cancel
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Cancel Schedule</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>Are you sure you want to cancel this schedule?</BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            Return
          </Button>
          <Button onClick={handleSubmit}>Cancel Schedule</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default CancelScheduleButton;
